module.exports = __webpack_public_path__ + "static/media/MainTransfer.f68f1a81.svg";